var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
var DEFAULT_MAX_NUM_LINES = 1;
var CSS_PROP_MAX_TEXT_LINES = 'WebkitLineClamp';
var ScCutter = styled.div.withConfig({ displayName: "ScCutter", componentId: "sc-1uc559w" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  /* stylelint-disable value-no-vendor-prefix */\n  display: -webkit-box;\n  /* stylelint-disable property-no-vendor-prefix */\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"], ["\n  /* stylelint-disable value-no-vendor-prefix */\n  display: -webkit-box;\n  /* stylelint-disable property-no-vendor-prefix */\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])));
var TextCutter = function (_a) {
    var _b;
    var className = _a.className, children = _a.children, title = _a.title, _c = _a.maxNumLines, maxNumLines = _c === void 0 ? DEFAULT_MAX_NUM_LINES : _c, rest = __rest(_a, ["className", "children", "title", "maxNumLines"]);
    return (_jsx(ScCutter, __assign({}, rest, { className: className, title: title, style: (_b = {},
            _b[CSS_PROP_MAX_TEXT_LINES] = maxNumLines,
            _b) }, { children: children }), void 0));
};
export { TextCutter, DEFAULT_MAX_NUM_LINES, CSS_PROP_MAX_TEXT_LINES };
var templateObject_1;
